import { render, staticRenderFns } from "./BulkSelection.vue?vue&type=template&id=21bbee10&scoped=true"
import script from "./BulkSelection.vue?vue&type=script&lang=ts"
export * from "./BulkSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbee10",
  null
  
)

export default component.exports